export default "__VITE_ASSET__DKYaUvSx__"